<template>
  <slot />
</template>

<script>
export default defineNuxtComponent({
  props: {
    blockIndex: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    // Provide priority context only for the first block
    provide('imagePriority', {
      isHighPriority: props.blockIndex < 1,
    });
  },
});
</script>
